import { baseURL as baseServerUrl } from "../Constants/api.constant";

// export var baseURL = "https://int-canvasai.ltimindtree.com";
export var baseURL = baseServerUrl;
